<template>
  <div class="h-full flex items-center justify-center">

    <div v-for="(step, idx) in prompts" :key="idx">
      <transition-group name="slide-fade"  mode="out-in">
        <Step
          v-show="idx === vuex_step-1"
          class="v-fade"
          :question="step.question"
          :input="step.input"
          :options="step.options"
          :key="get_random()"
        />
      </transition-group>
    </div>

  </div>
</template>



<script>
import Step from '../components/Step';
import { mapState } from 'vuex';

export default {
  name: 'Exam',
  components: {
    Step,
  },
  computed: {
    ...mapState({
      vuex_step: state => state.step,
      prompts: state => state.exam?.prompts
    })
  },
  methods: {
    get_random() {
      const uuid = (a) => a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
      // console.log(uuid());
      return uuid();
    }
  },
}
</script>